import { getSearchParams } from "../getSearchParams";
import { validateSearchParams } from "../validation";

/**
 * Generates a new href with a base path and a search params object. The function automatically
 * encodes special characters to query safe values.  If the basePath contains existing search parameters
 * (e.g., "path?existing=true"), these parameters are preserved and merged with the new searchParams.
 * In case of duplicate parameters, values from the searchParams parameter will override existing ones.
 *
 * @param {string} basePath The base of the HREF to create
 * @param {object} searchParams The search parameters that should be included in the HREF
 * @param {object} validations The yup validations to use when generating the HREF
 * @returns {string} An href with the combined base path and search parameters
 */
export const createHrefWithSearchParams = (basePath, searchParams, validations) => {
  const results = { errors: [], href: "" };
  const [strippedBasePath, existingSearchParamsString] = basePath.split("?");
  const { searchParams: existingSearchParams } = getSearchParams(existingSearchParamsString);
  const concatenatedSearchParams = { ...existingSearchParams, ...searchParams };
  let paramsToEncode = { ...concatenatedSearchParams };

  if (validations) {
    const { errors: validationErrors, searchParams: validatedSearchParams } = validateSearchParams(
      concatenatedSearchParams,
      validations
    );

    results.errors = validationErrors;
    paramsToEncode = validatedSearchParams;
  }

  const encodedParams =
    paramsToEncode && Object.keys(paramsToEncode).length > 0
      ? `?${new URLSearchParams(paramsToEncode)}`
      : "";

  results.href = `${strippedBasePath}${encodedParams}`;

  return results;
};
